module.exports = __webpack_public_path__ + "static/media/diamond.c5222735.svg";